import { Instance } from 'mobx-state-tree';
import * as React from 'react';
import { observer, inject } from 'mobx-react';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { TLCode } from '../../common/enums';
import styled from '@emotion/styled';
import TranslatedMessage from '../common/translation/TranslatedMessage';
import Dropzone from 'react-dropzone';
import { PlannerStore } from '../../store';
import { css } from 'emotion';
import PlannerFileLoadingModal from '../Planner/PlannerFileLoadingModal';
import { DivColumn, DivLine } from '../common/styledComponents/StyledComponents';
import {
  Button,
  ButtonGroup,
  NumericInput,
} from '@blueprintjs/core';
import { getSemester, getFirstMonday, getFirstSunday } from '../../common/utils';
import DateInput from '../common/input/DateInput';
import moment from 'moment';
import { TextInput } from '../common/input/basicInputs';

interface PlanningUploadTabProps extends WithTranslateProps {
  secretariatId?: number;
  refresh: () => void;
  PlannerStore?: Instance<typeof PlannerStore>;
}

interface PlanningUploadTabState {
  fileIsLoading?: boolean;
  modalFileLoadingOpened: boolean;
  dutiesImportError: string[];
  semesterYear: number;
  startDate: string;
  endDate: string;
  selectedStartRuleTransgressionDate: Date;
  selectedEndRuleTransgressionDate: Date;
  isMounted: boolean;
}

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const boxed = css({
  border: '1px solid green',
  height: '200px',
});

@inject('PlannerStore')
@observer
class PlanningUploadTab extends React.Component<PlanningUploadTabProps, PlanningUploadTabState> {
  state = {
    fileIsLoading: false,
    modalFileLoadingOpened: false,
    dutiesImportError: [],
    semesterYear: 2026,
    startDate: '',
    endDate: '',
    selectedStartRuleTransgressionDate: new Date(),
    selectedEndRuleTransgressionDate: new Date(),
    isMounted: false
  } as PlanningUploadTabState;

  cleanupBuffer = (buffer) => {
    return buffer.substring(39, 100).replace(/\//g, '-');
  };

  onImportModalClose = () => {
    this.setState({
      modalFileLoadingOpened: false,
      fileIsLoading: false,
    });
  };

  handleSemesterYearValueChange = (_valueAsNumber: number, _valueAsString: string) => {
    this.setState({ semesterYear: _valueAsNumber });
    //this.props.UiStore!.setDiagnosticPageCurrentSemesterYear(_valueAsNumber);
  };
  
    _isMounted = false;

    setStartDate = (date) => {
      this._isMounted &&
        this.setState({ startDate: moment(date).format('YYYY-MM-DD'), selectedStartRuleTransgressionDate: date });
      //this.props.UiStore!.setDiagnosticPageStartDate(date);
    };
  
    setEndDate = (date) => {
      this._isMounted &&
        this.setState({ endDate: moment(date).format('YYYY-MM-DD'), selectedEndRuleTransgressionDate: date });
      //this.props.UiStore!.setDiagnosticPageEndDate(date);
    };
  
  
    setS1 = () => {
      //this.handlePlanningIdValueChange(-1, '-1');
      //this.setState({ selectedPlanningId: {} });
      let date = getFirstMonday(this.state.semesterYear, 0);
      this.setStartDate(date);
  
      date = getFirstSunday(this.state.semesterYear, 6);
      this.setEndDate(date);
    };
  
    setS2 = () => {
      //this.handlePlanningIdValueChange(-1, '-1');
      //this.setState({ selectedPlanningId: {} });
      let date = getFirstMonday(this.state.semesterYear, 6);
      this.setStartDate(date);
  
      date = getFirstSunday(this.state.semesterYear + 1, 0);
      this.setEndDate(date);
    };

  async componentDidMount() {
    this._isMounted = true;
    this._isMounted && this.setState({ isMounted: true });
  };

  render() {
    const { fileIsLoading, modalFileLoadingOpened, dutiesImportError } = this.state;
    const { PlannerStore, translate } = this.props;

    const startDate = new Date(this.state.startDate);
    const endDate = new Date(this.state.endDate);

    const year = this.state.semesterYear;

    return (
      <Container>
        <TranslatedMessage id={TLCode.ROSTER_UploadDuties} />
                              <DivLine>{this.props.translate(TLCode.ANALYSIS_CLICK_SEMESTER)}</DivLine>
                              <DivLine>
                                {this.props.translate(TLCode.ROSTER_Year)}&nbsp;
                                <NumericInput
                                  style={{ width: '60px' }}
                                  min={2016}
                                  value={year}
                                  onValueChange={this.handleSemesterYearValueChange}
                                />
                                <ButtonGroup>
                                  <Button intent="primary" onClick={this.setS1}>
                                    <TranslatedMessage id={TLCode.ROSTER_S1} />
                                  </Button>
                                  &nbsp;&nbsp;
                                  <Button intent="primary" onClick={this.setS2}>
                                    <TranslatedMessage id={TLCode.ROSTER_S2} />
                                  </Button>
                                </ButtonGroup>

                                <DivLine>
                                {this.props.translate(TLCode.ANALYSIS_START)}&nbsp;&nbsp;
                                  <span style={{ width: '100px' }}>
                                    <DateInput
                                      value={startDate}
                                      disabled={false}
                                      //onChange={(value) => this.setState({ startDate: value })}
                                    />
                                  </span>
                                </DivLine>
                                <DivLine>
                                {this.props.translate(TLCode.ANALYSIS_END)}&nbsp;&nbsp;
                                  <span style={{ width: '100px' }}>
                                    <DateInput
                                      value={endDate}
                                      disabled={false}
                                      //onChange={(value) => this.setState({ endDate: value })}
                                    />
                                  </span>
                                </DivLine>
                              </DivLine>

        &nbsp;
        <Dropzone
          multiple={false}
          onDrop={(acceptedFiles) => {
            console.log(acceptedFiles);
            const reader = new FileReader();
            reader.onabort = () => console.log('file reading was aborted');
            reader.onerror = () => console.log('file reading has failed');
            reader.onload = () => {
              // Do whatever you want with the file contents
              const binaryStr = reader.result;
              const buffer = binaryStr!.toString();
              const buffer2 = this.cleanupBuffer(buffer);
              console.log(binaryStr);
            };
            acceptedFiles.forEach(async (file) => {
              this.setState({
                fileIsLoading: true,
                modalFileLoadingOpened: true,
              });
              const errors = await PlannerStore!.uploadClaudeFile(file, this.state.startDate, this.state.endDate);
              // @ts-ignore
              this.setState({ fileIsLoading: false, dutiesImportError: errors });
            });
          }}
        >
          {({ getRootProps, getInputProps }) => (
            <section>
              <div {...getRootProps()} className={boxed.toString()}>
                <input {...getInputProps()} />
                <p>{translate(TLCode.PLANNINGUPLOAD_DragAndDrop)}</p>
                <p>{translate(TLCode.PLANNINGUPLOAD_DragAndDrop_Example)}</p>
                <br />
                <DivLine>
                  {/* <DivColumn>
                    <div>
                      Pour l'<b>URPC</b> seulement, format Geowacht:
                    </div>
                    <div>654321;28-08-2025;1</div>
                    <div>654321;28-08-2025;4</div>
                    <div>765432;31-08-2025;1</div>
                    <br />
                  </DivColumn>
                  <DivColumn>&nbsp;</DivColumn>
                  <DivColumn>
                    <div>
                      Pour <b>les autres</b> secrétariats:
                    </div>
                    <div>Date;Type service de garde;N° APB</div>
                    <div>24/11/2020;Garde de jour;123456</div>
                    <div>25/11/2020;nuit;234567</div>
                    <p>26/11/2020;jour/nuit;345678</p>
                  </DivColumn> */}
                </DivLine>
              </div>
            </section>
          )}
        </Dropzone>
        <PlannerFileLoadingModal
          fileIsLoading={fileIsLoading}
          modalOpened={modalFileLoadingOpened}
          onClosed={this.onImportModalClose}
          errors={dutiesImportError}
        />
      </Container>
    );
  }
}

export default withTranslate(PlanningUploadTab);
